
export default {
  methods: {
    resetSameAddressDeliveryStates() {
      this.$store.dispatch("cartItem/SET_IS_SAME_ADDRESS_ORDER", false);
      this.$store.dispatch("cartItem/SET_CURR_SAME_ADDRESS_ORDER", null);
      this.$store.dispatch("cartItem/SET_CURR_SAME_ADDRESS_TOGGLE", null);
    },
    activateSameAddressDeliveryState() {
      this.$store.dispatch("cartItem/SET_IS_SAME_ADDRESS_ORDER", true);
    },
    isEligbleForDeliveryDiscount() {
      const isEdit = sessionStorage.getItem('editCartItemId');
      const currProduct = this.$store.state.cartItem.product;

      const currRegion = Object.keys(this.$store.state.cartItem.deliveryTown).length > 0
        ? this.$store.state.cartItem.deliveryTown.regionName
        : null;

      const currDeliveryDate = this.$store.state.cartItem.deliveryDate.length > 0
        ? this.$store.state.cartItem.deliveryDate
        : null;

      const existingSessionCartItems = sessionStorage.cartItems
        ? JSON.parse(sessionStorage.cartItems)
        : null;

      if(currProduct && currProduct.sku && currProduct.sku.toLowerCase().includes('_ca')){ //no applicable for canada post products
        return false;
      }

      if (existingSessionCartItems) {
        for (const key of Object.keys(existingSessionCartItems)) {
          console.log((isEdit && existingSessionCartItems && Object.keys(existingSessionCartItems).length > 1));
          console.log((!isEdit && Object.keys(existingSessionCartItems).length > 0));
          if (
            ((isEdit && existingSessionCartItems && Object.keys(existingSessionCartItems).length > 1) || (!isEdit && Object.keys(existingSessionCartItems).length > 0)) &&
            existingSessionCartItems[key].deliveryWindow.deliveryDate ===
            currDeliveryDate &&
            existingSessionCartItems[key].deliveryWindow.deliveryRegion ===
            currRegion && !existingSessionCartItems[key].product.productType.key.toLowerCase().includes('subscription')
          ) {
            return true;
          }
        }
      }

      return false;
    }
  },
};
